import React, { useEffect, useState } from "react";
import { Grid, Button } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { store } from "../../../../redux-store/store";
import { request } from "../../../../api/Service";
import "./newsales.scss";
import SelectSku from "../../../controls/SelectSku";
import { connect } from "react-redux";

const returnables = () => [
  { id: "true", title: "true" },
  { id: "false", title: "False" },
];

const initialFValues = {
  id: 0,
  categoryId: "",
  productName: "",
  unit: "",
  productDescription: "",
  sku: "",
  selectedQuantity: 0,
  returnable: "",
};

function NewSales(props) {
  const {
    addOrEdit,
    recordForEdit,
    categories,
    products,
    setOpenPopup,
    productList,
  } = props;
  const [file, setFile] = useState(null);
  const [startLoad, setStartLoad] = useState(false);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [imageId, setImageId] = useState("");
  const [quantity, setQuantity] = useState(0);
  const [salesPrice, setSalesPrice] = useState("");

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
  };
  var addToCart = (e) => {
    e.preventDefault();
    var payload = {
      selectedQuantity: values.quantity,
      salesPrice: salesPrice,
      sku: values.sku,
      imageId: imageId,
      productName: productName,
    };
    if (quantity < 1) {
      alert("You cannot add this item because it dosent exist in the store");
    } else {
      store.dispatch({
        type: "ADD_SELECTED_QUANTITY_OF_ITEM_TO_CART",
        payload: payload,
      });
      setOpenPopup(false);
    }
  };

  var fileRecord = null;
  var start = false;
  var state = {
    currentFile: undefined,
    previewImage: undefined,
    progress: 0,

    message: "",
    isError: false,
    imageInfos: [],
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  var getProduct = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    setStartLoad(true);
    request("get", {}, `get-web-product-by-sku?sku=${e.target.value}`)
      .then((data) => {
        console.log(data);
        setStartLoad(false);
        setProductName(data.productName);
        setQuantity(data.quantity);
        setProductDescription(data.productDescription);
        setImageId(data.imageId);
        setSalesPrice(data.salesPrice);
        // }
      })

      .catch(() => setStartLoad(false));
    console.log(getProduct);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var data = { ...values, formFile: file };
      addOrEdit(data, resetForm);
      setOpenPopup(false);
    }
  };

  const selectFile = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={addToCart}>
      <div className="relative">
        <SelectSku
          label="SKU"
          name="sku"
          value={values.sku}
          onChange={getProduct}
          options={productList}
          error={errors.sku}
        />{" "}
        <i className="fas fa-barcode fa-3x absolute bottom-4 right-40"></i>
      </div>
      {/* Here ends sku */}
      <div style={{ position: "relative", width: "100%" }}>
        <Controls.Input
          name="unit"
          label="Unit Price"
          value={salesPrice}
          onChange={handleInputChange}
          readOnly
        />
      </div>

      <Grid container>
        <Controls.Input
          name="productName"
          label="Product Name"
          value={productName || ""}
          onChange={handleInputChange}
          readOnly
        />
        <Controls.Input
          label="Product Description"
          name="productDescription"
          value={productDescription}
          onChange={handleInputChange}
          readOnly
        />
        <Controls.Input
          name="quantity"
          label="Quantity"
          type="number"
          min="1"
          value={values.quantity}
          onChange={handleInputChange}
          error={errors.quantity}
        />
        <button className="final-button">
          Add to Cart{" "}
          <i className={startLoad === true ? "fa fa-spinner fa-spin" : ""}></i>
        </button>
      </Grid>
    </Form>
  );
}

const mapStateToProps = (state) => {
  return {
    productList: state.productReducer.productList,
  };
};

export default connect(mapStateToProps)(NewSales);
